import { FC, useState } from 'react';
import { useWindowSize } from '../../hook/useWindowSize';
import { ResourceType } from '../../types/Resource';
import BusinessResourceDivider from '../business-resource-divider/business-resource-divider';
import BussinessResourceDownloadButton from '../business-resource-download-button/business-resource-download-button';
import BusinessResourceDownloadGrid from '../business-resource-download-grid/business-resource-download-grid';
import BusinessResourceTextWrap from '../business-resource-text-wrap/business-resource-text-wrap';
import styles from './business-resource-logos.module.scss';
import classNames from 'classnames';

export interface Props {
    downloadAllText?: string;
    resources?: ResourceType[];
    loading?: boolean;
    onDownload?: () => void;
}

const BusinessResourceLogosV2: FC<Props> = (props) => {
    const { downloadAllText = 'Download logos', resources, loading, onDownload } = props;
    const { width = 0 } = useWindowSize();

    return (
        <div className={classNames(styles.root, styles['v2'])}>
            <BussinessResourceDownloadButton containerClass={classNames(styles.downloadButton, styles['v2'])} onClick={onDownload} disabled={loading}>
                {downloadAllText}
            </BussinessResourceDownloadButton>

            {resources?.map((resource, index) => {
                const { id, title, description, description2, assets } = resource;

                return (
                    <div key={id || Math.random()}>
                        <BusinessResourceDivider />
                        <div className={styles.textContent}>
                            <BusinessResourceTextWrap size="small" caption={title} textAlign={width > 768 ? 'center' : 'left'} />
                            <BusinessResourceTextWrap size="large" content={description} textAlign={width > 768 ? 'center' : 'left'} />
                            <BusinessResourceTextWrap size="large" content={description2} textAlign={width > 768 ? 'center' : 'left'} />
                        </div>
                        {assets?.length ? <BusinessResourceDownloadGrid name={resource.type} items={assets} columns={2} cardMinHeight={205} hideDownloadAll /> : null}
                    </div>
                );
            })}

            <BussinessResourceDownloadButton containerClass={classNames(styles.downloadButton)} onClick={onDownload} disabled={loading}>
                {downloadAllText}
            </BussinessResourceDownloadButton>
        </div>
    );
};

export default BusinessResourceLogosV2;
